import { render, staticRenderFns } from "./LinkedPlatforms.vue?vue&type=template&id=7fbed900&scoped=true"
import script from "./LinkedPlatforms.vue?vue&type=script&lang=js"
export * from "./LinkedPlatforms.vue?vue&type=script&lang=js"
import style0 from "./LinkedPlatforms.vue?vue&type=style&index=0&id=7fbed900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbed900",
  null
  
)

export default component.exports